<div [ngClass]="{'contain-bo' : mobile}" class="container-fluid h-100" #content>
  <div #header class="row">
    <img [style.height.px]="mobile ? 35 : 80" class="col-auto" [src]="'upload.png' | getimage :'QLIB'" />
    <div class="col">
      <div [style.fontSize.rem]="mobile ? 1 : 2" class="q-c-main q-bold">{{'ext_uploadTitle' | trad}}</div>
      <p [style.fontSize.rem]="mobile ? 0.8 : 1" class="q-text-s q-bold">{{'ext_uploadSize' | trad}} : {{maxUploadSize}} Mo</p>
    </div>
  </div>
  
  <div class="row" [style.height]="sanitizer.bypassSecurityTrustStyle('calc(100% - ' + header.offsetHeight + 'px)')" >
    <q-insertdoc-input [ngClass]="{'col-xl-4': !boHidden}" class="col-12" [(eraseDocxFileIfNewDocIsPDF)]="eraseDocxFileIfNewDocIsPDF" [item]="model" [boHidden]="boHidden" (success)="success.emit($event)" [(file)]="file" onlyInput></q-insertdoc-input>
    <ng-container *ngIf="effectifs && effectifs.length > 0">
      <ng-container *ngFor="let effectif of effectifs">
        <q-effectifs class="col-12 col-md-6 col-xl my-3" style="min-height:450px;" height="450px;"
                     [Option]="effectif.Option"
                     (EffectifToEmit)="UpdateListEffectif($event, effectif.Origin, effectif.Relation)"></q-effectifs>
      </ng-container>
    </ng-container>
    <div *ngIf="!boHidden" [ngClass]="[effectifs && effectifs.length > 0 ? 'col-12' : 'col-xl-8 col-12', !mobile ? 'contain-bo h-100' : '']">
      <q-bodisplay [item]="model" [globalsave]="false" (sendEvent)="getEvent($event)"></q-bodisplay>
    </div>

  </div>
</div>
